export const BUSINESS = {
  name: "V.B. Sharada Associates",
  shortName: "VBS Associates",
  tagline: "Engineering Excellence, Structural Precision & Architectural Mastery in Tandur",
  description:
    "Professional contracting, building planning, building construction, interiors and engineering services firm in Tandur, Telangana.",
  description_te: "తాండూరు, తెలంగాణలో ప్రొఫెషనల్ కాంట్రాక్టింగ్, బిల్డింగ్ ప్లానింగ్, బిల్డింగ్ కన్స్ట్రక్షన్, ఇంటీరియర్స్ మరియు ఇంజనీరింగ్ సేవల సంస్థ.",
  address: "H - 2-2-18/2, Hyderabad Rd, behind VARUN MOTORS, SAIPUR, Indira Nagar, Tandur, Telangana 501141",
  phone: "+91 99661 81813",
  phoneAlt: "+91 90597 25248",
  email: "contact@vbsharadaassociates.com",
  whatsapp: "919440012345",
  hours: "Mon – Sat · 9:30 AM – 7:00 PM",
  hours_te: "సోమ – శని · ఉదయం 9:30 – సాయంత్రం 7:00",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1706164971302-e30c0640cc3b?crop=entropy&cs=srgb&fm=jpg&q=85",
  blueprint: "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&q=85",
  interior: "https://images.unsplash.com/photo-1697947656193-a87d460b5fb5?crop=entropy&cs=srgb&fm=jpg&q=85",
  lobby: "https://images.unsplash.com/photo-1648881806148-e5c51179c826?crop=entropy&cs=srgb&fm=jpg&q=85",
  engineer: "https://images.unsplash.com/photo-1630683924997-fe27050a0416?crop=entropy&cs=srgb&fm=jpg&q=85",
  steel: "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?crop=entropy&cs=srgb&fm=jpg&q=85",
  facade: "https://images.unsplash.com/photo-1691425700585-c108acad6467?crop=entropy&cs=srgb&fm=jpg&q=85",
  site: "https://images.unsplash.com/photo-1685464196387-854858ce0f4f?crop=entropy&cs=srgb&fm=jpg&q=85",
  ongoing: "https://images.unsplash.com/photo-1628744448839-a475cc0e90c3?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const SERVICE_ACCENTS = [
  { chip: "bg-orange-100 text-orange-600", bar: "from-orange-500 to-amber-400", ring: "border-orange-200", check: "text-orange-500" },
  { chip: "bg-teal-100 text-teal-600", bar: "from-teal-500 to-emerald-400", ring: "border-teal-200", check: "text-teal-600" },
  { chip: "bg-amber-100 text-amber-600", bar: "from-amber-500 to-yellow-400", ring: "border-amber-200", check: "text-amber-500" },
  { chip: "bg-blue-100 text-blue-600", bar: "from-blue-500 to-sky-400", ring: "border-blue-200", check: "text-blue-600" },
  { chip: "bg-purple-100 text-purple-600", bar: "from-purple-500 to-fuchsia-400", ring: "border-purple-200", check: "text-purple-600" },
];

export const SERVICES = [
  {
    id: "contracting",
    icon: "HardHat",
    title: "General Contracting",
    title_te: "జనరల్ కాంట్రాక్టింగ్",
    short: "End-to-end turnkey project execution with a single point of accountability.",
    short_te: "ఒకే బాధ్యతతో మొదటి నుండి చివరి వరకు టర్న్‌కీ ప్రాజెక్టు అమలు.",
    points: [
      "Turnkey civil & building contracts",
      "Material procurement & vendor management",
      "Labour, site supervision & safety compliance",
      "Transparent milestone-based billing",
    ],
    points_te: [
      "టర్న్‌కీ సివిల్ & బిల్డింగ్ కాంట్రాక్టులు",
      "మటీరియల్ కొనుగోలు & వెండార్ నిర్వహణ",
      "కూలీలు, సైట్ పర్యవేక్షణ & భద్రతా నిబంధనలు",
      "పారదర్శక మైల్‌స్టోన్-ఆధారిత బిల్లింగ్",
    ],
    image: "hero",
  },
  {
    id: "planning",
    icon: "DraftingCompass",
    title: "Building Planning & Approvals",
    title_te: "బిల్డింగ్ ప్లానింగ్ & అప్రూవల్స్",
    short: "Vastu-aware floor plans, working drawings and complete municipal liaison.",
    short_te: "వాస్తు ప్రకారం ఫ్లోర్ ప్లాన్‌లు, వర్కింగ్ డ్రాయింగ్‌లు మరియు పూర్తి మున్సిపల్ అనుమతులు.",
    points: [
      "Architectural floor plans & elevations",
      "Municipal / DTCP approval liaison",
      "Structural drawings & BOQ preparation",
      "Vastu-compliant layout options",
    ],
    points_te: [
      "ఆర్కిటెక్చరల్ ఫ్లోర్ ప్లాన్‌లు & ఎలివేషన్లు",
      "మున్సిపల్ / DTCP అప్రూవల్ సాయం",
      "స్ట్రక్చరల్ డ్రాయింగ్‌లు & BOQ తయారీ",
      "వాస్తు ప్రకారం లేఅవుట్ ఎంపికలు",
    ],
    image: "blueprint",
  },
  {
    id: "construction",
    icon: "Building2",
    title: "Building Construction",
    title_te: "బిల్డింగ్ కన్స్ట్రక్షన్",
    short: "Residential and commercial construction engineered for durability.",
    short_te: "మన్నికైన నిర్మాణం కోసం రెసిడెన్షియల్ & కమర్షియల్ కన్స్ట్రక్షన్.",
    points: [
      "Independent houses & villas",
      "Apartments & commercial complexes",
      "Renovation, extension & retrofitting",
      "Quality-assured branded materials",
    ],
    points_te: [
      "స్వతంత్ర ఇళ్లు & విల్లాలు",
      "అపార్ట్‌మెంట్లు & కమర్షియల్ కాంప్లెక్స్‌లు",
      "రెనోవేషన్, విస్తరణ & మరమ్మతులు",
      "నాణ్యమైన బ్రాండెడ్ మటీరియల్స్",
    ],
    image: "steel",
  },
  {
    id: "interiors",
    icon: "Sofa",
    title: "Interior Design & Execution",
    title_te: "ఇంటీరియర్ డిజైన్ & అమలు",
    short: "Functional, elegant interiors for homes, offices and commercial spaces.",
    short_te: "ఇళ్లు, ఆఫీసులు మరియు కమర్షియల్ స్థలాలకు అందమైన, ఉపయోగకరమైన ఇంటీరియర్స్.",
    points: [
      "Modular kitchens & wardrobes",
      "Office & retail space interiors",
      "False ceiling, lighting & woodwork",
      "3D design previews before execution",
    ],
    points_te: [
      "మాడ్యులర్ కిచన్లు & వార్డ్‌రోబ్‌లు",
      "ఆఫీస్ & రిటైల్ స్పేస్ ఇంటీరియర్స్",
      "ఫాల్స్ సీలింగ్, లైటింగ్ & చెక్కపని",
      "అమలుకు ముందు 3D డిజైన్ ప్రివ్యూలు",
    ],
    image: "interior",
  },
  {
    id: "engineering",
    icon: "Ruler",
    title: "Structural Engineering & Valuation",
    title_te: "స్ట్రక్చరల్ ఇంజనీరింగ్ & వాల్యుయేషన్",
    short: "Structural audits, stability certificates and professional property valuation.",
    short_te: "స్ట్రక్చరల్ ఆడిట్లు, స్టెబిలిటీ సర్టిఫికెట్లు మరియు ప్రొఫెషనల్ ప్రాపర్టీ వాల్యుయేషన్.",
    points: [
      "Structural design & stability checks",
      "Building valuation reports for banks",
      "Site feasibility & soil coordination",
      "Third-party quality inspection",
    ],
    points_te: [
      "స్ట్రక్చరల్ డిజైన్ & స్టెబిలిటీ తనిఖీలు",
      "బ్యాంకుల కోసం బిల్డింగ్ వాల్యుయేషన్ నివేదికలు",
      "సైట్ ఫీజిబిలిటీ & నేల పరీక్ష సమన్వయం",
      "థర్డ్-పార్టీ నాణ్యతా తనిఖీ",
    ],
    image: "engineer",
  },
];

export const PROJECTS = [
  {
    id: 1,
    title: "Sharada Enclave Villas",
    category: "Residential Villas",
    location: "Tandur",
    scale: "12,500 sq.ft · 6 villas",
    scale_te: "12,500 చ.అ. · 6 విల్లాలు",
    status: "Completed",
    image: "hero",
  },
  {
    id: 2,
    title: "SR Commercial Complex",
    category: "Commercial Complexes",
    location: "Tandur",
    scale: "28,000 sq.ft · G+3",
    scale_te: "28,000 చ.అ. · G+3",
    status: "Completed",
    image: "facade",
  },
  {
    id: 3,
    title: "Green Valley Residency",
    category: "Residential Villas",
    location: "Kodangal",
    scale: "8,400 sq.ft · Duplex",
    scale_te: "8,400 చ.అ. · డూప్లెక్స్",
    status: "In Progress",
    image: "steel",
  },
  {
    id: 4,
    title: "Sri Sai Residence Interiors",
    category: "Interiors",
    location: "Tandur",
    scale: "2,600 sq.ft · 3BHK",
    scale_te: "2,600 చ.అ. · 3BHK",
    status: "Completed",
    image: "interior",
  },
  {
    id: 5,
    title: "Agro Warehouse Structure",
    category: "Structural Planning",
    location: "Peddamul",
    scale: "40,000 sq.ft · Steel frame",
    scale_te: "40,000 చ.అ. · స్టీల్ ఫ్రేమ్",
    status: "Completed",
    image: "engineer",
  },
  {
    id: 6,
    title: "Sunshine Corporate Office",
    category: "Commercial Complexes",
    location: "Vikarabad",
    scale: "15,000 sq.ft · G+2",
    scale_te: "15,000 చ.అ. · G+2",
    status: "In Progress",
    image: "lobby",
  },
  {
    id: 7,
    title: "Lakeview Apartment Interiors",
    category: "Interiors",
    location: "Tandur",
    scale: "4 units · Turnkey",
    scale_te: "4 యూనిట్లు · టర్న్‌కీ",
    status: "Completed",
    image: "interior",
  },
  {
    id: 8,
    title: "Town Hall Renovation Plan",
    category: "Structural Planning",
    location: "Tandur",
    scale: "22,000 sq.ft · Audit & retrofit",
    scale_te: "22,000 చ.అ. · ఆడిట్ & మరమ్మతు",
    status: "Upcoming",
    image: "blueprint",
  },
];

export const PROJECT_FILTERS = ["All", "Residential Villas", "Commercial Complexes", "Interiors", "Structural Planning"];

export const TESTIMONIALS = [
  {
    name: "Ramesh Chandra",
    name_te: "రమేష్ చంద్ర",
    role: "Villa Owner, Tandur",
    role_te: "విల్లా యజమాని, తాండూరు",
    quote:
      "From plan approval to handover, everything was managed professionally. The quality of construction and finishing exceeded our expectations.",
    quote_te:
      "ప్లాన్ అప్రూవల్ నుండి హ్యాండోవర్ వరకు అన్నీ ప్రొఫెషనల్‌గా నిర్వహించారు. కన్స్ట్రక్షన్ నాణ్యత మరియు ఫినిషింగ్ మా అంచనాలను మించిపోయాయి.",
  },
  {
    name: "S. Vijaya Lakshmi",
    name_te: "ఎస్. విజయ లక్ష్మి",
    role: "Commercial Space Owner",
    role_te: "కమర్షియల్ స్పేస్ యజమాని",
    quote:
      "Clear billing, weekly progress updates and on-time delivery. V.B. Sharada Associates is the most dependable contractor we have worked with.",
    quote_te:
      "స్పష్టమైన బిల్లింగ్, వారపు పురోగతి అప్‌డేట్‌లు మరియు సమయానికి డెలివరీ. మేము పనిచేసిన అత్యంత నమ్మకమైన కాంట్రాక్టర్ V.B. శారద అసోసియేట్స్.",
  },
  {
    name: "Mohammed Faisal",
    name_te: "మహమ్మద్ ఫైసల్",
    role: "Interior Client, Vikarabad",
    role_te: "ఇంటీరియర్ క్లయింట్, వికారాబాద్",
    quote:
      "Their interior team turned our office into a space clients compliment every day. Design previews before execution made decisions easy.",
    quote_te:
      "వారి ఇంటీరియర్ టీమ్ మా ఆఫీసును క్లయింట్లు రోజూ ప్రశంసించే స్థలంగా మార్చింది. అమలుకు ముందు డిజైన్ ప్రివ్యూలు నిర్ణయాలు సులభం చేశాయి.",
  },
];

export const STATS = [
  { value: "15+", label: "Years of Experience", label_te: "సంవత్సరాల అనుభవం" },
  { value: "120+", label: "Projects Delivered", label_te: "పూర్తయిన ప్రాజెక్టులు" },
  { value: "5,00,000+", label: "Sq.ft Constructed", label_te: "నిర్మిత చ.అడుగులు" },
  { value: "98%", label: "On-time Handover", label_te: "సమయానికి హ్యాండోవర్" },
];

export const ENQUIRY_STATUSES = ["New", "Contacted", "In Review", "Completed"];

export const ESTIMATOR_RATES = {
  Residential: { Standard: 1650, Premium: 1950, Luxury: 2450 },
  Commercial: { Standard: 1850, Premium: 2200, Luxury: 2850 },
  Interiors: { Standard: 950, Premium: 1450, Luxury: 2100 },
  "Structural Plan": { Standard: 28, Premium: 38, Luxury: 52 },
};

export const pick = (obj, field, lang) => (lang === "te" && obj[`${field}_te`]) || obj[field];

export const mapsEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(BUSINESS.address)}&output=embed`;
export const mapsDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(BUSINESS.address)}`;
export const whatsappUrl = `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(
  "Hello V.B. Sharada Associates, I would like to discuss a construction / interiors project."
)}`;

export const formatINR = (n) => "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n);
